import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import { formatDateTime, getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import InfoboxWithIcon from './ListItems/InfoboxWithIcon';

class VehicleDetailsReservationContent extends React.Component {
  getReservation = () => {
    const { vehicle, match } = this.props;
    const reservations = vehicle ? vehicle.maintenance_reservations : [];
    let reservation = match
      ? reservations.find(x => x.id == match.params.reservationId)
      : undefined;
    if (!reservation && vehicle && reservations.length) {
      reservation = reservations[0];
    }
    return reservation;
  }

  renderDetailRow = (label, value, screenSize) => {
    if (!value && value !== false) return null;
    return (
      <div style={getStyle(screenSize, styles, 'detailRow')}>
        <p style={getStyle(screenSize, styles, 'detailLabel')}>{label}</p>
        <p style={getStyle(screenSize, styles, 'detailValue')}>{value}</p>
      </div>
    );
  }

  render() {
    const { t } = this.props;

    const reservation = this.getReservation();

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'contentContainer')}>
            {reservation && (
              <React.Fragment>
                <div>
                  <div style={getStyle(screenSize, styles, 'topInfoContainer')}>
                    <InfoboxWithIcon
                      icon='/img/icon_calendar.svg'
                      text={formatDateTime(reservation.start)}
                      labelText={t('reservationStartTime')}
                    />
                    <InfoboxWithIcon
                      icon='/img/icon_calendar.svg'
                      text={formatDateTime(reservation.end)}
                      labelText={t('reservationEndTime')}
                      hasBorders
                    />
                    <InfoboxWithIcon
                      icon='/img/icon_car_service.svg'
                      text={reservation.workshop_name}
                      labelText={t('workshopInfobox')}
                    />
                  </div>
                  <div style={getStyle(screenSize, styles, 'mainContentContainer')}>
                    <div style={getStyle(screenSize, styles, 'textContainer')}>
                      {reservation.description && (
                        <div>
                          <p style={getStyle(screenSize, styles, 'headingText')}>
                            {t('reservationDescription')}
                          </p>
                          <p style={getStyle(screenSize, styles, 'descriptionText')}>
                            {reservation.description}
                          </p>
                        </div>
                      )}
                    </div>
                    <div style={getStyle(screenSize, styles, 'detailsGrid')}>
                      {this.renderDetailRow(t('reservationWorkOrderNr'), reservation.work_order_nr, screenSize)}
                      {this.renderDetailRow(t('reservationOrganization'), reservation.organization_name, screenSize)}
                      {this.renderDetailRow(t('reservationBooker'), reservation.user_name || reservation.user_id, screenSize)}
                      {this.renderDetailRow(
                        t('reservationCreatedAt'),
                        reservation.autofutur_created ? moment(reservation.autofutur_created).format('DD.MM.YYYY') : null,
                        screenSize
                      )}
                      {this.renderDetailRow(
                        t('reservationPartsOrdered'),
                        reservation.part_items_ordered ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' }),
                        screenSize
                      )}
                      {this.renderDetailRow(
                        t('reservationPreReservation'),
                        reservation.is_pre_reservation ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' }),
                        screenSize
                      )}
                      {this.renderDetailRow(
                        t('reservationStandardNotation'),
                        reservation.standard_notation,
                        screenSize
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            {!reservation && (
              <div style={getStyle(screenSize, styles, 'noContentContainer')}>
                <p style={getStyle(screenSize, styles, 'noContentText')}>
                  {t('noReservationsText')}
                </p>
              </div>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    contentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 1)',
      minHeight: 500,
      width: '75%',
      padding: 16,
    },
    topInfoContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginLeft: -16,
      marginRight: -16,
    },
    mainContentContainer: {
      marginTop: 16,
    },
    headingText: {
      fontSize: 18,
      color: 'white',
    },
    descriptionText: {
      fontSize: 14,
      color: 'white',
    },
    textContainer: {
      marginBottom: 16,
    },
    detailsGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 0,
      borderTop: '1px solid rgba(255, 255, 255, 0.2)',
      paddingTop: 16,
    },
    detailRow: {
      width: '50%',
      marginBottom: 16,
    },
    detailLabel: {
      fontSize: 12,
      color: 'rgba(255, 255, 255, 0.6)',
      marginBottom: 2,
    },
    detailValue: {
      fontSize: 15,
      color: 'white',
    },
    noContentContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
    },
    noContentText: {
      fontSize: 18,
      color: 'white',
    },
  },
  small: {
    contentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'transparent',
      minHeight: 500,
      width: '100%',
      padding: 0,
    },
    topInfoContainer: {
      display: 'flex',
      justifyContent: 'normal',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
    },
    mainContentContainer: {
      backgroundColor: 'rgba(0, 149, 218, 1)',
      padding: 16,
    },
    detailRow: {
      width: '100%',
      marginBottom: 12,
    },
  },
};

export default translate('VehicleDetailsView')(VehicleDetailsReservationContent);
